import useUrl from '~/composables/useUrl';

type parentTypes =
  | 'opiniepanel'
  | 'eenvandaag-vraagt'
  | 'uitlegvideos'
  | 'doe-mee'
  | 'peilingtrends';

export default function useIsChildPageOf(): parentTypes | '' {
  const url = useUrl();

  // Mapping of prefixes to their respective return values
  const pathMappings: Record<string, parentTypes> = {
    '/opiniepanel': 'opiniepanel',
    '/eenvandaag-vraagt': 'eenvandaag-vraagt',
    '/doe-mee': 'doe-mee',
    '/uitlegvideos': 'uitlegvideos',
    '/peilingtrends': 'peilingtrends',
  };

  // Find the first matching prefix
  for (const [prefix, value] of Object.entries(pathMappings)) {
    if ((url.pathname || '').startsWith(prefix)) {
      return value;
    }
  }

  return '';
}
